import React from 'react';
import { renderToString } from 'react-dom/server';
import type { TributeClientItem, TributeOptions } from 'core/types';

const options: TributeOptions = {
  trigger: '@',
  lookup: 'name',
  values: [],
  fillAttr: 'name',
  allowSpaces: true,
  selectTemplate: (item: TributeClientItem) => {
    // @ts-ignore
    return renderToString(<plugin code={item.original.code}>{item.original.name}</plugin>);
  },
};

export default options;
